import { useCallback, useEffect, useState } from "react";
import api from "../../util/axios";

type Props = {
    url: string;
    params?: Record<string, string | number | boolean>;
};


export const useGet = <T>(props:Props) => {

    const { url } = props;
    const [value, setValue] = useState<T>();
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);


    const getCall = async(
        params?: Record<string, string | number | boolean>
    ) => {
        
        setLoading(true);
        setValue(undefined);
        setError(undefined);

        await api
            .get(url)
            .then(res => setValue(res.data))
            .catch(e  => setError(e))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        getCall(props.params);
    }, [url])

    return {
        value,
        loading,
        error,
        getCall
    };
}